module.exports = __webpack_public_path__ + "static/media/guncock.203be4f5.mp3";